import React, { useEffect } from 'react';
import { Mail, LifeBuoy, FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { Button } from '../components/ui/button';

function SupportPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="Soporte - Cloudbase"
        description="Centro de ayuda y soporte de Cloudbase. Escríbenos para recibir asistencia con la plataforma."
        keywords="soporte cloudbase, ayuda, contacto"
        path="/soporte"
        breadcrumbs={[
          { name: 'Inicio', item: '/' },
          { name: 'Soporte', item: '/soporte' }
        ]}
      />
      <div className="min-h-screen bg-white" data-testid="support-page">
        <Header />

        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-br from-gray-900 via-gray-800 to-black">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-green-600/20 border border-green-600/30 text-green-400 rounded-full text-sm font-semibold">
                <LifeBuoy className="w-4 h-4" />
                Centro de Ayuda
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-white">
                Estamos aquí para ayudarte
              </h1>
              <p className="text-xl text-gray-300">
                Nuestro equipo responde consultas sobre configuración, uso de módulos e integraciones de Cloudbase.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
              <div className="grid md:grid-cols-2 gap-6">
                <a
                  href="mailto:soporte@cloudbase.cl"
                  className="block bg-white border border-gray-200 hover:border-green-500 hover:shadow-lg p-8 rounded-lg transition-all group"
                  data-testid="support-email-card"
                >
                  <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <Mail className="w-7 h-7 text-green-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Escríbenos</h3>
                  <p className="text-gray-600 mb-3">
                    Envíanos tu consulta y te respondemos en menos de 24 horas hábiles.
                  </p>
                  <p className="text-green-600 font-semibold group-hover:underline">
                    soporte@cloudbase.cl
                  </p>
                </a>

                <a
                  href="/demo"
                  className="block bg-white border border-gray-200 hover:border-green-500 hover:shadow-lg p-8 rounded-lg transition-all group"
                  data-testid="support-demo-card"
                >
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <FileText className="w-7 h-7 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Solicitar demo</h3>
                  <p className="text-gray-600 mb-3">
                    ¿Aún no eres cliente? Agenda una demo personalizada con nuestro equipo.
                  </p>
                  <p className="text-blue-600 font-semibold group-hover:underline">
                    Ir a /demo
                  </p>
                </a>
              </div>

              <div className="mt-12 text-center">
                <Button
                  size="lg"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 rounded font-semibold"
                  onClick={() => (window.location.href = 'mailto:soporte@cloudbase.cl')}
                  data-testid="support-cta-email"
                >
                  Contactar Soporte
                </Button>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}

export default SupportPage;
